import { Controller } from '@hotwired/stimulus';

// The back office rail, open or shut — fire/views/layouts/fire/hq.
//
// One class on the drawer, read by everything inside it through Tailwind's
// `group-[.rail-shut]:` variant, so nothing here has to know what the rail
// is made of. The cookie is not a nicety: the server reads it to draw the
// first frame already shut, and without it the rail flashes open on every
// page load and snaps closed a frame later.
//
// Registered as "hq-rail" and not "sidebar": more than one app has a
// sidebar controller of its own for the front of the house.
export default class extends Controller {
  toggle() {
    // Below lg the rail is daisyUI's overlay: this button shuts it and
    // hands focus back to the checkbox, whose ring is the menu button's.
    // 64rem is Tailwind's lg, read off the browser default in every host.
    if (!matchMedia('(min-width: 64rem)').matches) {
      // This drawer's own checkbox: #fire-rail in /hq, #org-rail in nbe's front.
      const box = this.element.querySelector(':scope > .drawer-toggle');
      box.checked = false;
      box.focus();
      return;
    }
    const shut = this.element.classList.toggle('rail-shut');
    document.cookie = `fire_rail=${shut ? 'shut' : 'open'};path=/;max-age=31536000;samesite=lax`;
  }
}
